module.exports = __webpack_public_path__ + "images/vector/app/web/src/assets/documents icon-66dd6128.svg";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/assets/documents icon.svg
// module id = ./app/web/src/assets/documents icon.svg
// module chunks = 0